/**
 * ExpiryWarningDialog Component
 *
 * Warning dialog when the session is about to expire (≤ 1 minute).
 */

import { Dialog } from '@soteria/design-system-ve';
import type { ReactElement } from 'react';

interface ExpiryWarningDialogProps {
  /** Whether the dialog is visible */
  isOpen: boolean;
  /** Handler to dismiss the warning */
  onDismiss: () => void;
}

/** Warning dialog shown when the moderation session TTL is about to expire */
export function ExpiryWarningDialog({ isOpen, onDismiss }: ExpiryWarningDialogProps): ReactElement | null {
  if (!isOpen) return null;

  return (
    <Dialog
      isOpen
      description="You have less than 1 minute left in your moderation session. Please complete your current work and submit soon."
      primaryAction={{
        label: 'Continue',
        onClick: onDismiss,
        variant: 'primary',
      }}
      title="One Minute Remaining"
      onClose={onDismiss}
    >
      {null}
    </Dialog>
  );
}
